import styled from 'styled-components';

import { Button } from '@xsolla/ui-core';

export const SettingsBar = styled.div<{ extraSettings: boolean }>`
  display: flex;
  position: relative;
  justify-content: ${(props) => (props.extraSettings ? 'space-between' : 'center')};
  align-items: center;
  border-bottom: 1px solid ${(props) => props.theme.colors.stroke};
  padding: 14px 22px;
`;

export const SettingsBarLabel = styled.span`
  ${(props) => props.theme.typography.caption};
  margin-right: 18px;
`;

export const SettingsBarOptionsButton = styled(Button)`
  text-align: start;
`;
